export enum SortType {
    Asc,
    Desc
}

export function createComparerOfSorting<T, TV>(memberSelector: (obj: T) => TV = null, type: SortType = SortType.Desc) {
    const aReturn = type === SortType.Desc ? 1 : -1;
    const bReturn = type === SortType.Desc ? -1 : 1;
    return (a: T, b: T) => {
        if (memberSelector) {
            let aa = memberSelector(a);
            let bb = memberSelector(b);
            if (aa < bb) return aReturn;
            if (aa > bb) return bReturn;
            return 0;
        }
        if (a < b) return aReturn;
        if (a > b) return bReturn;
        return 0;
    };
}

export function flatten<T>(array: T[][]): T[] {
    return [].concat(...array);
}

export function groupBy<T>(array: T[], key: string | number): Map<string, T[]> {
    //expecting keys has same order as inserted
    const result = new Map<string, T[]>();
    array.forEach(item => {
        const keyValue = item[key];
        if (result.has(keyValue)) {
            result.get(keyValue).push(item);
            return;
        }
        result.set(keyValue, [item]);
    })
    return result;
}

export function max(items: any[], memberSelector?: (item: any) => number): number {
    if (!items.length) return 0;
    let currentMax = Number.MIN_SAFE_INTEGER;
    items.forEach(item => {
        const valueToCompare = memberSelector ? memberSelector(item) : item;
        if (valueToCompare > currentMax) {
            currentMax = valueToCompare;
        }
    });
    return currentMax;
}

export function min(items: any[], memberSelector?: (item: any) => number): number {
    if (!items.length) return 0;
    let currentMin = Number.MAX_SAFE_INTEGER;
    items.forEach(item => {
        const valueToCompare = memberSelector ? memberSelector(item) : item;
        if (valueToCompare < currentMin) {
            currentMin = valueToCompare;
        }
    });
    return currentMin;
}

export function sum(items: number[]): number {
    return items.reduce((a, b) => a + b, 0);
}

export function immutableSplice<T>(array: T[], start: number, deleteCount: number, ...items: T[]): T[] {
    const newArray = [...array];
    newArray.splice(start, deleteCount, ...items);
    return newArray;
}

export function uniqueValues(origin: any[]): any[] {
    return origin.filter((v, i, a) => a.indexOf(v) === i);
}

export const isArrayOfStrings = (value: any): boolean => {
    return Array.isArray(value) && value.every(item => typeof item === "string");
}
